<template>
  <div class="protocol_detail_list_area">
    <h2 class="list_tit">목차</h2>
    <ul class="protocol_detail_list">
      <li :class="{active: selected.index == index && scrollMode}" v-for="(item, index) in indexList" @click="indexSelect(item, index)">
        <a href="javascript:;" v-html="setTitleName(index, item)"></a>
      </li>
    </ul>
  </div>
</template>

<script>
import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";

export default{
  props: {
    indexList: {type:Array, default:[]},
    scrollMode: {type:Boolean, default: false}
  },
  data() {
    return {
      selected:{}
    }
  },
  mounted() {
    this.selectItem(0);
    this.$emit('mounted', {
      handler: {
        select: this.selectItem
      }
    })
  },
  methods: {
    indexSelect(item, index) {
      this.selected = {
        item, index
      }
      this.$emit('itemSelect', this.selected);
    },
    selectItem(index){
      this.selected = {
        item : this.indexList[index],
        index
      }
    },
    scorllEvent(target) {

    },
    setTitleName(index, item){
      let resultText = item.text || item.title;
      const startsWithNumber = /^[0-9]/.test(resultText);
      if(!startsWithNumber){
        resultText = (index+1)+'. ' + resultText;
      }
      return resultText;
    },
  }
}
</script>